// extracted by mini-css-extract-plugin
module.exports = {"container":"search-input-m__container__1p1X7","search":"search-input-m__search__3wAOj"};